import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class AssetAddPhotoEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: AssetAddPhotoEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetAddPhotoEvent.type = 'com.treeplotter.api.asset.addPhoto.v1';
EventRegistry.register(AssetAddPhotoEvent.type, AssetAddPhotoEvent);
//# sourceMappingURL=asset-add-photo.event.js.map